export default __webpack_public_path__ + "static/testimonialCompanyLogo1-e20f81faa2bce7f8d364100df2abc231.svg";